import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Auth from '@aws-amplify/auth';
import { MatSnackBar } from '@angular/material/snack-bar';
import { localImages, stringsList } from '../dashboard/constants/app-config';
import { LoginModel } from './login.model';
import { ClientService } from '../dashboard/preview/invoices/services/client.service';
import { View } from '../dashboard/preview/models/view.model';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-viber-login',
  templateUrl: './viber-login.component.html',
  styleUrls: ['./viber-login.component.css']
})
export class ViberLoginComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  localImages = localImages;
  stringsList = stringsList;
  hide: boolean = false;
  loginData: LoginModel = {
    email: '',
    password: '',
    confirmPassword: '',
    opt: '',
  };
  otp: string = '';
  view: View = {
    isLogin: true, //on treba da je true
    isForgotPassword: false,
    isVerify: false, // privrmeno je true
    isNewPassword: false,
    isSuccess: false,
  };
  formGroup!: UntypedFormGroup;
  titleAlert: string = 'This field is required';
  post: string = '';
  isLoading: boolean = false;
  isLoadingDots: boolean = false;
  changingPassword: boolean = false;
  errorMessage: string | null = null;
  showConfirmPassword: boolean = false;
  showPassword: boolean = false;
  isWrongCode: boolean = false;
  isSubmitting: boolean = false;
  logoUrl: string = '/assets/logo 3.svg'; // Default fallback logo
  account_validation_messages = {
    username: [
      { type: 'required', message: 'Username is required' },
      {
        type: 'minlength',
        message: 'Username must be at least 4 characters long',
      },
      {
        type: 'maxlength',
        message: 'Username cannot be more than 25 characters long',
      },
      {
        type: 'validUsername',
        message: 'Your username has already been taken',
      },
    ],
    password: [
      { type: 'required', message: 'Password is required' },
      {
        type: 'pattern',
        message:
          'Password needs to be at least eight characters, one uppercase letter and one number',
      },
    ],
    confirmPassword: [
      { type: 'required', message: 'Password is required' },
      {
        type: 'pattern',
        message:
          'Password needs to be at least eight characters, one uppercase letter and one number',
      },
    ],
    opt: [{ type: 'required', message: 'OPT is required' }],
  };
  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private clinetService: ClientService,
    private userService: UserService,
    private route: ActivatedRoute,
  ) {
    // this.formGroup = this.formBuilder.group({
    //   name: [null, Validators.required],
    //   password: [null, [Validators.required]],
    // });

    this.updateWindowWidth();
    this.updateColumnVisibility();
  }

  ngOnInit(): void {
    this.redirectUser();
    this.createForm();
    
    // Get logoUrl from localStorage for display
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        if (user.logoUrl) {
          this.logoUrl = user.logoUrl;
        }
      } catch (error) {
        console.error('Error parsing userInfo from localStorage:', error);
      }
    }
  }

  changeView(
    viewName:
      | 'isLogin'
      | 'isForgotPassword'
      | 'isVerify'
      | 'isNewPassword'
      | 'isSuccess'
  ): void {
    this.errorMessage = null;
    this.view.isForgotPassword = false;
    this.view.isVerify = false;
    this.view.isLogin = false;
    this.view.isSuccess = false;
    this.view.isNewPassword = false;
    this.view[viewName] = true;
  }

  verifyCode() {
    this.isWrongCode = false;
    this.changeView('isNewPassword');
  }

  sendVerificationCode(): void {
    Auth.forgotPassword(this.loginData.email)
      .then(() => {
        this.snackBar.open('SUCCESS, code sent to your email.', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        this.errorMessage = null;
        this.changeView('isVerify');
      })
      .catch((err) => {
        console.log(err);
        this.errorMessage = "Hmm, we don't recognise that username.";
        // this.timeOutErrorMessage();
      });
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      name: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(25),
        ]),
      ],

      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})$'
          ),
        ]),
      ],
    });
  }

  onOtpChange($event: string) {
    this.otp = $event;
  }

  redirectUser() {
    // Auth.currentAuthenticatedUser({
    //   bypassCache: false,
    // })
    //   .then(() => {
    //     this.router.navigate(['']);
    //   })
    //   .catch(() => {
    //     this.router.navigate(['/login']);
    //   });
  }

  async signIn(post: LoginModel): Promise<void> {
    this.isLoadingDots = true;
    try {
      let user = await Auth.signIn(post.email, post.password);
      let userInfo = await Auth.currentUserInfo();

      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        await Auth.completeNewPassword(user, post.password);
        user = await Auth.signIn(post.email, post.password);
        userInfo = await Auth.currentUserInfo();
      }
      const isUserExist: any = await this.clinetService.GetClient(
        userInfo.attributes.sub
      );
      localStorage.setItem(
        'userInfo',
        JSON.stringify({ phone: isUserExist.phone, email: isUserExist.email, isVatIncluded: isUserExist.isVatIncluded })
      );
      if (!isUserExist) {
        await Auth.signOut();
        throw new Error("User doesn't exist in database");
      }

      if (isUserExist.status === 'DISABLED') {
        await Auth.signOut();
        throw new Error('Your profile is disabled!');
      }

      localStorage.setItem('userID', userInfo.attributes.sub);
      if (
        !user.signInUserSession.idToken.payload['cognito:groups'].includes(
          'CLIENT'
        )
      ) {
        await Auth.signOut();
        throw new Error('Wrong informations provided');
      }
      const tokens = user.signInUserSession;
      if (tokens != null) {
        console.log(tokens)
        console.log('user', user)

        await this.handleViberAuthentication()

        this.redirectToViberBot()

        this.isLoadingDots = false;
      }
      Auth.currentAuthenticatedUser({
        bypassCache: false,
      }).catch((err) => console.log(err));
    } catch (error: any) {
      console.log('cauht errpr')
      console.log(error);
      this.isLoadingDots = false;
      if (error.code == 'UserNotFoundException') {
        this.titleAlert = error.message;
        this.formGroup.controls['name'].setErrors({ incorrect: true });
      }
      if (error.code == 'NotAuthorizedException') {
        this.titleAlert = error.message;
        this.formGroup.controls['name'].setErrors({ incorrect: true });
        this.formGroup.controls['password'].setErrors({ incorrect: true });
      }
      if (error.code == 'UserNotConfirmedException') {
        this.titleAlert = 'Account not confirmed!';
        Auth.resendSignUp(this.loginData.email).then((res) => {
          this.router.navigate(['/signup'], {
            queryParams: { step: 1, username: this.loginData?.email },
          });
          this.snackBar.open(
            'Please, confirm your account before attempting to log in!',
            '',
            {
              duration: 7000,
              panelClass: ['white-snackbar'],
            }
          );
          return;
        });
      }
      console.log(error.message);
      if (error.message == 'User does not exist.' || error.message == 'Incorrect username or password.') {
        this.errorMessage = 'Invalid username and password combination.';
      } else {
        this.errorMessage = error.message;
      }
    }
  }

  sendLoginLink(loginData: LoginModel) {
    Auth.forgotPassword(loginData.email)
      .then((res) => {
        this.errorMessage = null;
        this.changeView('isNewPassword');
      })
      .catch((err) => {
        console.log('err', err);
        this.errorMessage = 'Wrong informations provided, please check again.';
        this.timeOutErrorMessage();
      });
  }

  changePassword(loginData: LoginModel) {
    if (loginData.password !== loginData.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;
    } else {
      this.errorMessage = null;
    }
    this.changingPassword = true;
    Auth.forgotPasswordSubmit(
      loginData.email,
      this.otp,
      loginData.confirmPassword
    )
      .then(() => {
        this.errorMessage = null;
        this.signIn(loginData);
        this.changingPassword = false;
      })
      .catch((err) => {
        console.log('err', err.message);
        if (
          err.message == 'Invalid verification code provided, please try again.'
        ) {
          this.errorMessage = 'Invalid verification code provided.';
          this.isWrongCode = true;
          this.changingPassword = false;
          return;
        }

        this.errorMessage = 'Wrong informations provided, please check again.';
        //this.timeOutErrorMessage();
        this.changingPassword = false;
      });
  }

  timeOutErrorMessage() {
    setTimeout(() => {
      this.errorMessage = null;
    }, 3000);
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  goBackToEnteringCodeScreen() {
    this.isWrongCode = false;
    this.changeView('isVerify');
    this.errorMessage = '';
  }

  redirectToSignUp() {
    this.router.navigate(['/signup']);
  }



  showSecondColumn = true; // Initially show the second column
  windowWidth: number = 1080;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateWindowWidth();
    this.updateColumnVisibility();
  }

  private updateWindowWidth(): void {
    this.windowWidth = window.innerWidth;
  }

  private updateColumnVisibility(): void {
    // Check if the window width is less than 680px and hide the second column accordingly
    this.showSecondColumn = this.windowWidth >= 680;
  }

  redirectToViberBot( ) {
    let botURI = "companyinclouds-automation"
    if ( window.location.href.includes(".dev") ){
      botURI = "companyinclouds"
    }
    document.location = `viber://pa?chatURI=${botURI}` 
  }

  async handleViberAuthentication() { 
    console.log("ayyooo")
    try {
      let qparams : any = {}
      await this.route.queryParams.subscribe(params =>{ qparams = params})
      const token = qparams.token
      const user = await Auth.currentAuthenticatedUser()
      console.log('userInfo', user)
      const userSub = user.attributes.sub
      console.log('userSub', userSub)

      let res = await this.userService.authenticateViberID(token)
      console.log('res', res)

    } catch (error) {
      console.log('error', error)
    }
  }
}
